/**
 * An API media path, as a URL the browser can load.
 *
 * Images are stored outside the webroot and served from the API's own origin, so a stored
 * `/media/…` path resolves against the admin's origin unless it is made absolute here.
 */
const API_ORIGIN = import.meta.env.VITE_AWJ_API_URL ?? 'http://localhost:5092';

export function mediaUrl(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }

  return /^(https?:|data:)/.test(url) ? url : `${API_ORIGIN}${url.startsWith('/') ? '' : '/'}${url}`;
}
